<template>
  <div
    v-if="
      data.paymentType &&
      data.paymentType.find((p) => p.active) &&
      (data.paymentType.filter((p) => p.active).length > 1 ||
        !data.showPaymentHideView)
    "
    id="theme--tuktuk__payment-method"
    class="theme--tuktuk__card"
  >
    <div class="theme--tuktuk__container">
      <h2 class="theme--tuktuk__title">{{ data.titlePayment }}</h2>
      <div class="theme--tuktuk__payment-method__list" style="gap: 0px;">
        <template
          v-for="(pType, ind) in paymentType"
        >
          <div
            v-bind:key="ind"
            v-if="pType.type != 'E-Payment'"
            class="tuktuk__payment-method__list__option"
            @click="handlePaymentSelection(pType.type, pType.name, data.totalPrice < 1 || isPaymentCODUnsupported(pType))"
          >
            <vs-radio :val="pType.type" v-model="data.payload.payment" :disabled="data.totalPrice < 1 || isPaymentCODUnsupported(pType)" class="theme--tuktuk__radio">
              <div class="tuktuk__payment-method__list__option__content">
                <div class="tuktuk__payment-method__list__option__content__title">
                  <img
                    width="42px"
                    height="30px"
                    alt=""
                    class=""
                    :src="
                      pType.type == 'COD'
                        ? require('@/assets/icons/Payments/payment-cod.png')
                        : require('@/assets/icons/Payments/payment-bank_transfer.png')
                    "
                  /><span>{{ $t(`payment.type.${pType.type}`) }}</span>
                </div>
                <div v-if="isPaymentCODUnsupported(pType)" class="unsupported-badge">
                  <img src="@/assets/icons/x-circle-contained.svg" alt="icon" style="width: 14px; height: 14px;">                
                  <span class="fm-text-error-800 fm-text-caption fm-font-medium">Alamat tidak terjangkau</span>
                </div>
              </div>
            </vs-radio>

            <div class="m0 admin-fee" style="color: #C47E0A" v-if="data.totalPrice < 1">
                Minimal transfer Rp1
            </div>
          </div>

          <template v-else v-for="(elem, i) in data.epaymentSettings" >
            <div
              v-if="elem.active"
              :key="ind + i"
              @click="handlePaymentSelection(elem.id, 'E-Payment', elem.id === 'bca_va' ? data.totalPrice < 10000 : data.totalPrice < 1)"
              class="tuktuk__payment-method__list__option"
              :style="{ borderColor: data.payload.payment === elem.id ? 'transparent' : '#E0E9F4' }"
            >
              <vs-radio
                v-bind:key="i"
                :val="elem.id"
                v-model="data.payload.payment"
                :disabled="elem.id === 'bca_va' ? data.totalPrice < 10000 : data.totalPrice < 1"
                class="theme--tuktuk__radio"
              >
                <img
                  width="42px"
                  height="30px"
                  alt=""
                  class="payment-image"
                  :src="
                    pType.id == 'COD'
                      ? require('@/assets/icons/Payments/payment-bank_transfer.png')
                      : require('@/assets/icons/Payments/' + elem.id + '.png'
                          ? '@/assets/icons/Payments/' + elem.id + '.png'
                          : '@/assets/icons/Payments/' + elem.id + '.svg')
                  "
                />
                <div>
                  {{ elem.label }}
                  <template v-if="data.ePaymentFeePaidBy === 'buyer'">
                    <p class="admin-fee m-0" v-if="elem.id === 'gopay'">{{ $t('settings.adminEPayFeeGopay') }}</p>
                    <p class="admin-fee m-0" v-else-if="elem.id === 'QRIS'">{{ $t('settings.adminEPayFeeQRIS') }}</p>
                    <p class="admin-fee m-0" v-else-if="elem.id === 'credit_card'">{{ $t('settings.adminEPayFeeCreditCard') }}</p>
                    <p class="admin-fee m-0" v-else>{{ $t('settings.adminEPayFeeOther') }}</p>
                  </template>
                </div>
              </vs-radio>
              
              <div v-if="elem.id === 'bca_va' ? data.totalPrice < 10000 : data.totalPrice < 1" class="m0 admin-fee" style="color: #C47E0A">
                Minimal transfer {{elem.id === 'bca_va' ? 'Rp10.000' : 'Rp1'}}
              </div>
            </div>
            <div :key="'info'+ind + i" v-if="data.payload.payment === elem.id" class="fs-12 fw-500 text-center" style="background-color: #D6E0F7; padding: 8px; color: #113B98; margin: 0 -15px;">
              {{ $t('settings.processByMidtrans') }}
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ["data", "isAddressUnsupported"],
  data() {
    return {
      availablePaymentMethod: "all"
    };
  },
  components: {},
  computed: {
    paymentType() {
      let paymentType = this.data.paymentType.filter((p) => p.active)

      if (this.availablePaymentMethod == "cod") {
        paymentType = this.data.paymentType.filter((p) => p.active && p.type == "COD")
      } else if (this.availablePaymentMethod == "nonCod") {
        paymentType = this.data.paymentType.filter((p) => p.active && (p.type == "bankTransfer" || p.type == "E-Payment"))
      }

      return paymentType
    },
  },
  watch: {
    'data.payload.address': {
      async handler(val) {
        if (val) {
          this.checkAvailablePaymentMethod(val)
        }
      },
      deep: true,
    },
    availablePaymentMethod: {
      handler() {
        this.autoSelectPayment();
      },
    },
    "data.paymentType": {
      handler() {
        this.autoSelectPayment();
      },
      deep: true,
    },
    "data.epaymentSettings": {
      handler() {
        this.autoSelectPayment();
      },
      deep: true,
    },
  },
  mounted() {
    this.autoSelectPayment();
  },
  methods: {
    setStep(count) {     
      this.$emit("setStep", count);
    },
    changeMode(param) {
      this.data.payload.paymentMode = param;
    },
    handlePaymentSelection(payment, paymentMode, disabled = false) {
      if (disabled) return;

      this.data.payload.payment = payment;
      this.changeMode(paymentMode);
      this.$set(this.data.payload, '_paymentSelectedByBuyer', true);
    },
    checkAvailablePaymentMethod(address) {
      this.data.excludeShippingLocation.forEach((item) => {
        if (item.type == "province") {
          if (address && address.PROVINCE && address.PROVINCE.toLowerCase() == item.PROVINCE_NAME.toLowerCase()) {
            this.availablePaymentMethod = item.paymentMethod;
          }
        } else if (item.type == "city") {
          if (address && address.CITY && address.CITY.toLowerCase() == item.CITY_NAME.toLowerCase()) {
            this.availablePaymentMethod = item.paymentMethod;
          }
        } else if (item.type == "district") {
          if (
              address &&
              address.PROVINCE &&
              address.PROVINCE.toLowerCase() == item.PROVINCE_NAME.toLowerCase() &&
              address.CITY &&
              address.CITY.toLowerCase() == item.CITY_NAME.toLowerCase() &&
              address.DISTRICT &&
              address.DISTRICT.toLowerCase() == item.DISTRICT_NAME.toLowerCase()
            )
          {
            this.availablePaymentMethod = item.paymentMethod;
          }
        }
      })
    },
    changeDefaultPayment(val) {
      this.data.payload.payment = val;
    },
    autoSelectPayment() {
      let paymentType = this.data.paymentType.filter((p) => p.active)

      if (this.availablePaymentMethod == "cod") {
        paymentType = this.data.paymentType.filter((p) => p.active && p.type == "COD")
      } else if (this.availablePaymentMethod == "nonCod") {
        paymentType = this.data.paymentType.filter((p) => p.active && (p.type == "bankTransfer" || p.type == "E-Payment"))
      }

      const buyerPaymentIsAvailable = this.data.payload._paymentSelectedByBuyer && (
        paymentType.some((paymentTypeOption) => paymentTypeOption.type === this.data.payload.payment) ||
        paymentType.some((paymentTypeOption) =>
          paymentTypeOption.type === 'E-Payment' && this.data.epaymentSettings.some((option) => option.active && option.id === this.data.payload.payment)
        )
      )
      if (buyerPaymentIsAvailable) return

      for (const paymentTypeOption of paymentType) {
        if (paymentTypeOption.type == "E-Payment") {
          const activeEPayment = this.data.epaymentSettings.find((payment) => payment.active)
          if (!activeEPayment) continue

          this.changeDefaultPayment(activeEPayment.id)
        } else {
          this.changeDefaultPayment(paymentTypeOption.type)
        }

        this.changeMode(paymentTypeOption.name)
        this.$set(this.data.payload, '_paymentSelectedByBuyer', false)
        return
      }
    },
    isPaymentCODUnsupported(pType) {
      return pType.type === 'COD' && this.isAddressUnsupported.unsupported_cod && !this.isAddressUnsupported.unsupported;
    },
  },
};
</script>

<style lang="scss">
#theme--tuktuk__payment-method {
  .theme--tuktuk__title {
    margin-bottom: 8px !important;
  }
}
.tuktuk__payment-method__list__option {
    padding: 8px 0px;
    &:last-of-type {
        padding-bottom: 0px;
        border-bottom: none;
    }

    .vs-radio__label {
        display: flex;
        align-items: center;
        font-size: 12px !important;
        font-family: TikTokDisplayMedium !important;
        height: 36px !important;

        & > div {
          height: 36px !important;
        }

        .admin-fee {
            font-size: 12px;
            font-weight: 400;
            color: #6C7E95;
            font-size: 12px !important;
            font-family: TikTokDisplayRegular !important;
        }
    }
    .tuktuk__payment-method__list__option__content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex: 1;

      .tuktuk__payment-method__list__option__content__title {
        display: flex;
        align-items: center;
        gap: 8px;
      }
    }
}
.unsupported-badge {
  display: flex;
  align-items: center;
  gap: 2px;
  height: 22px;
  padding: 4px 6px;
  font-size: 11px;
  font-weight: 500;
  color: #E12121;
  background-color: #FFE3E3;
  border-radius: 4px;
  font-family: inter;
}
.vs-radio-content.disabled {
  opacity: 1;

  .tuktuk__payment-method__list__option__content 
  {
    .tuktuk__payment-method__list__option__content__title {
      span {
        color: #BFCEE0;
      }
    }
  }
}
</style>
